import { useTranslation } from 'react-i18next';
import {
  BellIcon,
  ChartBarIcon,
  InformationCircleIcon,
  LockClosedIcon,
  SparklesIcon,
  UserCircleIcon,
  UsersIcon,
} from '@heroicons/react/24/outline';
import { useFeatureFlagEnabled } from 'posthog-js/react';

import { useCurrentPartner } from 'services/repositories/partners/partners';
import { FEATURE_FLAGS } from 'support/helpers/featureFlags/featureFlags';
import { PartnerType, SettingsRoutes } from 'support/types';

import { SecondaryNavigation } from '../../../components/Page/SecondaryNavigation/SecondaryNavigation';
import { NavigationLinkGroup } from '../../../components/Page/types';

export function SettingsSidebar() {
  const { t } = useTranslation();
  const showUsageAndModules = useFeatureFlagEnabled(FEATURE_FLAGS.USAGE_AND_MODULES);
  const { data: currentPartner } = useCurrentPartner();
  const isNetworkMember = currentPartner?.partnerType === PartnerType.NETWORK_MEMBER;
  const linkGroups: Array<NavigationLinkGroup> = [
    {
      title: t('settings:sidebar.companyWorkspace'),
      links: [
        {
          href: SettingsRoutes.usageAndModules,
          label: t('settings:sidebar.usageAndModules'),
          icon: <ChartBarIcon />,
          hidden: isNetworkMember || !showUsageAndModules,
        },
        {
          href: SettingsRoutes.companyData,
          label: t('settings:sidebar.companyData'),
          icon: <InformationCircleIcon />,
          hidden: false,
        },
        {
          href: SettingsRoutes.ssccSettings,
          label: t('settings:sidebar.ssccSettings'),
          hidden: !currentPartner?.ssccSettingsAvailable,
        },
        {
          href: SettingsRoutes.teamMembers,
          label: t('settings:sidebar.teamMembers'),
          icon: <UsersIcon />,
          hidden: false,
        },
        {
          href: SettingsRoutes.notificationsManagement,
          label: t('settings:sidebar.notificationsManagement'),
          icon: <BellIcon />,
          hidden: false,
        },
        {
          href: SettingsRoutes.productMasterdata,
          label: t('settings:sidebar.productMasterdata'),
          hidden: !currentPartner?.documentUnderstandingAgentInboxEnabled,
        },
        {
          href: SettingsRoutes.documentUnderstandingAgent,
          label: t('settings:sidebar.documentUnderstandingAgent'),
          icon: <SparklesIcon />,
          hidden: !currentPartner?.documentUnderstandingAgentInboxEnabled,
        },
      ],
    },
    {
      title: t('settings:sidebar.account'),
      links: [
        {
          href: SettingsRoutes.profileAndPreferences,
          label: t('settings:sidebar.profileAndPreferences'),
          icon: <UserCircleIcon />,
          hidden: false,
        },
        {
          href: SettingsRoutes.password,
          label: t('settings:sidebar.password'),
          icon: <LockClosedIcon />,
          hidden: false,
        },
      ],
    },
  ];

  return <SecondaryNavigation linkGroups={linkGroups} />;
}
